window.addEventListener("load", function () {
    var swiper = new Swiper(".list_reward", {
        
        pagination: {
          el: ".swiper-pagination.swiper-pagination--gr-check",
          clickable: true,
        },
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 30,
        loop: false,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
        breakpoints: {
          769: {
              slidesPerView: 5,
              slidesPerGroup: 5,
          }
      }
    });
    $(".list_reward .item").each(function(index) {
      var $btnNhan = $(this).find(".btn_nhan");
      
      if ($(this).hasClass("received")) {
        $btnNhan.text($btnNhan.data("received"));
    } else {
        $btnNhan.text($btnNhan.data("default")) ;
    }
      
  });
  
});